import { startCheckout, getPayment, releasePayment, getSubMerchant, saveSubMerchant,
         getOrders, requestRefund, getRefunds, processRefund, getPaymentAnalytics } from '../services/api';

// ── Customer starts paying for an accepted quote ──
// On success returns { paymentPageUrl, token, payment_id }. The caller redirects
// the browser to paymentPageUrl (iyzico-hosted Checkout Form). Card data never
// touches our site.
export const handleStartCheckout = async (quoteId) => {
  try {
    const res = await startCheckout(quoteId);
    return { success: true, data: res.data };
  } catch (err) {
    const status = err.response?.status;
    if (status === 503) {
      return { error: 'Ödeme sistemi şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.' };
    }
    return { error: err.response?.data?.message || 'Ödeme başlatılamadı.' };
  }
};

// ── Poll a payment's final state (used on the result page) ──
export const handleGetPayment = async (id) => {
  try {
    const res = await getPayment(id);
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'Ödeme durumu alınamadı.' };
  }
};

// ── Customer confirms delivery → release escrow to the supplier ──
export const handleReleasePayment = async (id) => {
  try {
    const res = await releasePayment(id);
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'İşlem tamamlanamadı.' };
  }
};

// ── Supplier: load own iyzico banking (sub-merchant) profile ──
export const handleGetSubMerchant = async () => {
  try {
    const res = await getSubMerchant();
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'Ödeme bilgileri alınamadı.' };
  }
};

// ── Supplier: create/update iyzico banking profile ──
export const handleSaveSubMerchant = async (data) => {
  try {
    const res = await saveSubMerchant(data);
    return { success: true, data: res.data };
  } catch (err) {
    const errors = err.response?.data?.errors;
    if (errors) {
      const first = Object.values(errors)[0];
      return { error: Array.isArray(first) ? first[0] : first };
    }
    return { error: err.response?.data?.message || 'Kaydedilemedi.' };
  }
};

// ── Orders (role-aware: customer/supplier/admin) ──
export const handleGetOrders = async () => {
  try {
    const res = await getOrders();
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'Siparişler yüklenemedi.' };
  }
};

// ── Customer requests a refund (iade) with a reason ──
export const handleRequestRefund = async (paymentId, reason) => {
  try {
    const res = await requestRefund(paymentId, { reason });
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'İade talebi oluşturulamadı.' };
  }
};

// ── Refund requests list (role-aware) ──
export const handleGetRefunds = async () => {
  try {
    const res = await getRefunds();
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'İade talepleri yüklenemedi.' };
  }
};

// ── Admin approves/rejects a refund request ──
export const handleProcessRefund = async (refundId, action, note = '') => {
  try {
    const res = await processRefund(refundId, { action, note });
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'İşlem başarısız.' };
  }
};

// ── Admin: payment revenue + commission analytics ──
export const handleGetPaymentAnalytics = async () => {
  try {
    const res = await getPaymentAnalytics();
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'Gelir verileri yüklenemedi.' };
  }
};
